/* Boop & Bean: Storm Kit sales page interactions. Reveal on scroll, delivery dates, the scramble/ready switch, the calm-day slider and the final size picker. */
(function () {
  if (window.__bbx) return;
  window.__bbx = 1;
  var d = document;
  d.documentElement.classList.add('bbx-page');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  function each(sel, fn, ctx) { Array.prototype.forEach.call((ctx || d).querySelectorAll(sel), fn); }
  function addBusinessDays(from, n) {
    var x = new Date(from.getTime()), c = 0;
    while (c < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) c++; }
    return x;
  }
  function dm(x) { return x.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' }); }
  function wdm(x) { return x.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function daysUntil(month, day) {
    var now = new Date(); now.setHours(0, 0, 0, 0);
    var t = new Date(now.getFullYear(), month - 1, day);
    if (t < now) t.setFullYear(t.getFullYear() + 1);
    return Math.round((t - now) / 864e5);
  }

  ready(function () {
    /* Reveal on scroll */
    var rev = d.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      Array.prototype.forEach.call(rev, function (e) { io.observe(e); });
    } else {
      Array.prototype.forEach.call(rev, function (e) { e.classList.add('is-in'); });
    }

    /* Delivery and storm-ready dates (8 to 15 business days, plus a week of calm days) */
    var today = new Date(), a = addBusinessDays(today, 8), b = addBusinessDays(today, 15), r = new Date(b.getTime());
    r.setDate(r.getDate() + 7);
    each('[data-eta-range]', function (e) { e.textContent = dm(a) + ' and ' + dm(b); });
    each('[data-eta-today]', function (e) { e.textContent = 'Today, ' + dm(today); });
    each('[data-eta-arrive]', function (e) { e.textContent = dm(a) + ' to ' + dm(b); });
    each('[data-eta-ready]', function (e) { e.textContent = wdm(r); });
    each('[data-count]', function (e) {
      var p = e.getAttribute('data-count').split('-'), n = daysUntil(+p[0], +p[1]), out = e.querySelector('b');
      if (out) out.textContent = n === 0 ? 'today' : n + (n === 1 ? ' day away' : ' days away');
    });

    /* The mid-storm scramble vs ready before the rumble */
    each('[data-bbx-switch]', function (sw) {
      var box = sw.closest('[data-bbx]'), flow = box.querySelector('.bbx-flow'), tabs = sw.querySelectorAll('[role="tab"]');
      function set(m, focus) {
        sw.setAttribute('data-mode', m);
        if (flow) flow.setAttribute('data-mode', m);
        Array.prototype.forEach.call(tabs, function (t) {
          var on = t.getAttribute('data-mode') === m;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        each('[data-panel]', function (p) { p.hidden = p.getAttribute('data-panel') !== m; }, box);
      }
      Array.prototype.forEach.call(tabs, function (t) {
        t.addEventListener('click', function () { sw.classList.add('is-touched'); set(t.getAttribute('data-mode')); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault(); sw.classList.add('is-touched');
            set(t.getAttribute('data-mode') === 'scramble' ? 'ready' : 'scramble', true);
          }
        });
      });
    });

    /* Calm-day introduction slider */
    each('[data-bbx-days]', function (w) {
      var data = [];
      try { data = JSON.parse(w.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
      var input = w.querySelector('input[type="range"]'), dayEl = w.querySelector('[data-day]'), st = w.querySelector('[data-stage]'), last = 0;
      function stage(n) { return n <= 2 ? 0 : n <= 4 ? 1 : n <= 6 ? 2 : 3; }
      function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      function update() {
        var n = +input.value, s = stage(n);
        if (dayEl) dayEl.textContent = n;
        input.style.setProperty('--p', ((n - 1) / 6 * 100) + '%');
        input.setAttribute('aria-valuetext', 'Day ' + n + ': ' + data[s].t);
        if (s !== last) {
          last = s;
          st.innerHTML = '<p class="bbx-days__label">' + esc(data[s].d) + '</p><h3>' + esc(data[s].t) + '</h3><p>' + esc(data[s].x) + '</p>';
          st.classList.remove('is-swap'); void st.offsetWidth; st.classList.add('is-swap');
        }
      }
      input.addEventListener('input', update);
      update();
    });

    /* Final size picker: adds the kit (the theme's kit-gift script adds the free Lick Mat), then goes to the cart */
    each('[data-bbx-buy]', function (f) {
      var btn = f.querySelector('button[type="submit"]'), label = btn.querySelector('span'), msg = f.querySelector('[data-msg]'), price = f.querySelector('[data-price]'), base = f.getAttribute('data-label') || 'Add the Storm Kit';
      f.addEventListener('change', function () {
        var r = f.querySelector('input[name="id"]:checked');
        if (!r) return;
        btn.disabled = false;
        label.textContent = base + ' · ' + r.getAttribute('data-price');
        if (price) {
          price.textContent = r.getAttribute('data-price');
          var from = price.previousSibling;
          if (from && from.nodeType === 3) from.textContent = '';
        }
        if (msg) msg.textContent = '';
      });
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var r = f.querySelector('input[name="id"]:checked');
        if (!r) { if (msg) msg.textContent = 'Choose a size first.'; return; }
        btn.disabled = true; label.textContent = 'Adding to your cart…';
        window.fetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(r.value, 10), quantity: 1 }] })
        }).then(function (res) {
          if (!res.ok) throw new Error('add');
          window.location.href = root + 'cart';
        }).catch(function () {
          btn.disabled = false; label.textContent = 'Try again';
          if (msg) msg.textContent = "Sorry, that didn't go through. Please try again, or use Add to cart at the top of the page.";
        });
      });
    });
  });
})();
